import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SignInProps } from "@/@types";
import { observer } from "mobx-react";
import { autorun } from "mobx";
import {
  useTheme,
  Stack,
  Typography,
  List,
  ListItem,
  SvgIcon,
  Container,
} from "@mui/material";
import { navbarMenuList as AuthorizedMenuList } from "../Navbar/AuthorizedNavbarMenu";
import { navbarMenuList as UnAuthorizedMenuList } from "../Navbar/UnauthorizedNavbarMenu";
import { ReactComponent as Email } from "@/assets/icons/Email.svg";

const Footer = observer((props: SignInProps) => {
  const theme = useTheme();
  const nevigate = useNavigate();

  const [navbarMenuList, setNavbarMenuList] = useState<
    {
      label: string;
      href: string;
    }[]
  >([]);

  useEffect(() => {
    const disposeAutorun = autorun(() => {
      setNavbarMenuList(
        props.userStore.isLogin ? AuthorizedMenuList : UnAuthorizedMenuList,
      );
    });
    return () => {
      disposeAutorun();
    };
  }, [props.userStore]);

  return (
    <Container
      sx={{
        width: "90%",
        maxWidth: props.userStore.isLogin ? "1776px !important" : undefined,
        height: theme.footerHeight,
        zIndex: "10",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        height="100%"
      >
        <Stack direction="row" alignItems="center" gap="27px">
          <List
            sx={{
              display: "flex",
              padding: 0,
              margin: 0,
            }}
          >
            {[
              ...navbarMenuList,
              {
                label: "Terms of service",
                href: "/terms",
              },
              {
                label: "Privacy policy",
                href: "/privacy",
              },
            ].map((item) => (
              <ListItem
                key={item.href}
                onClick={() => {
                  nevigate(item.href);
                }}
                sx={{
                  p: "0",
                  mx: "27px",
                  fontSize: theme.typography.body2.fontSize,
                  fontWeight: theme.typography.body2.fontWeight,
                  lineHeight: theme.typography.body2.lineHeight,
                  color: theme.typography.body2.color,
                  letterSpacing: " 0.08em",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                {item.label}
              </ListItem>
            ))}
          </List>
          <Stack direction="row" alignItems="center" gap="15px">
            <SvgIcon
              component={Email}
              sx={{
                height: "24px",
                width: "auto",
                aspectRatio: "1/1",
                fill: "none",
              }}
              inheritViewBox
            />
            <Typography variant="body2">
              contact email: p2p-support@hap.land
            </Typography>
          </Stack>
        </Stack>
        <Typography variant="body2">2023 All rights reserved.</Typography>
      </Stack>
    </Container>
  );
});

export default Footer;
